
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2055_6148)","stroke":"#F1A348"}},[_c('path',{attrs:{"d":"M6.788 8.708L5.333 7.174l1.455-1.533","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.333 7.175h4c.354 0 .693.157.943.435.25.28.39.658.39 1.052v.322a2 2 0 01-2 2h-.933","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.834 8.312c0 3.783-3.06 6.847-6.834 6.847-3.773 0-6.833-3.065-6.833-6.847 0-3.782 3.06-6.846 6.833-6.846s6.834 3.064 6.834 6.846z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2055_6148"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .298)","d":"M0 0h16v16.029H0z"}})])])])
          )
        }
      }
    